<svg bind:this={element} use:useActions={use} use:forwardEvents {...$$restProps}
  ><slot /></svg
>

<script>// @ts-ignore Need to use internal Svelte function
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from './internal/index.js';
if (console && console.warn) {
    console.warn('The @smui/common Svg component is deprecated. You can use `tag="svg"` now.');
}
// Remember to update $$Props if you add/remove/rename props.
export let use = [];
const forwardEvents = forwardEventsBuilder(get_current_component());
let element;
export function getElement() {
    return element;
}
</script>
